<script setup>
import {computed} from 'vue'

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const pageSectionTemplates = computed(() => pageEditorStore.pageSectionTemplates)
const activeSectionId = computed(() => pageEditorStore.activeSectionId)

const sectionData = computed(() => pageEditorStore.pageSectionData?.find(o => o.id === activeSectionId.value))

const sectionTemplateId = computed({
    get() {
        return sectionData.value?.sectionTemplateId || 0
    },
    set(newValue) {
        pageEditorStore.saveSectionTemplateId(newValue)
    }
})
</script>

<template>
    <select v-model="sectionTemplateId" class="form-select form-select-sm w-auto">
        <option value="" selected disabled>Select&hellip;</option>
        <option v-for="o in pageSectionTemplates" :key="o.id" :value="o.id">
            {{ o.title }}
        </option>
    </select>
</template>